export const toAbsoluteUrl = (pathname) => window.ENVVARS.REACT_APP_PUBLIC_URL + pathname
